import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import Select from 'react-select'; //04-03-2024-multiselect

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';

export default function Bvoc_ProgramMap() {

  const [admissionYears, setAdmissionYears] = useState([]);
  const [discipline, setDisciplineData] = useState([]);
  const [selected, setSelected] = useState(false);
  const [selectedAdmission, setSelectedAdmission] = useState(false);
  const [selctedsem, setsem] = useState(1);
  const [getresults, setResults] = useState(false);
  const [minors, setMinors] = useState([]);
  const [mdc, setMdc] = useState([]);
  const [Major, setMajor] = useState([]);
  const [SEC, setSec] = useState([]);
  const [Core, setCore] = useState([]);
  const [MDE, setMDE] = useState([]);
  const [Elective, setElective] = useState([]);
  const [VAC, setVAC] = useState([]);
  const [AEC, setAEC] = useState([]);
  const [OJT, setOJT] = useState([]);

  const [response, setResponse] = useState([]);
  const [flag, setflag] = useState(false);
  const [active, setActiveSemester] = useState(false);

  const [current, setCurrent] = useState({
    major: [],
    minor: [],
    mdc: [],
    sec: [],
    core: [],
    mde: [],
    electives: [],
    vac: [],
    aec: [],
    ojt: [],

  });
  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/");
  }

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/College/getBvocYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
        toast.error("Error fetching admission years:");
      }
    };
    fetchAdmissionYears()


  }, []);


  const handleadmissionyear = (selectedOptions) => {

    const Adimission_year = selectedOptions.value;

    setSelectedAdmission({ Adimission_year: Adimission_year });

  };

  useEffect(() => {

    let cid = localStorage.getItem("collegeid");
    // let cid = 28;
    const fetchData = async () => {



      try {



        const response2 = await http.get(`/College/getBvocCollegeDisciplinesforprogrammap`, {
          params: {
            limit: '500',
            college_id: cid,
            admission_year: selectedAdmission.Adimission_year
          }
        });

        if (response2.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response2.data);

      } catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
          toast.error(error.response.data.message.message);


        }
        else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Course data:', error);
      }
    };

    if(selectedAdmission !==false){
        fetchData();
    }
    
  }, [selectedAdmission]);

  useEffect(() => {

    http.get(`/College/getBvocActiveEventsForProgramMap`, { params: { event_id: 1, admission_year: selectedAdmission.Adimission_year, semester_id: selctedsem } }).then(response => {

      if (response.data.http_status === 500) {
        setsem(1);
      }
      else if (response.data.length > 0) {
        const activeSemesters = response.data[0].semester_id;
        const status = response.data[0].status;


        if (status === "active" && selectedAdmission.Adimission_year == response.data[0].admission_year) {
          setsem(activeSemesters);
          setActiveSemester(activeSemesters);

        }
      }
      else {
        setActiveSemester(false);
      }


    }).catch(error => {

      console.error("Error in getStudentCourseEvents:", error);
      //toast.error("Something went wrong");
    });
  }, [selectedAdmission.Adimission_year, selctedsem]);


  const save = async () => {

    //Check if Major has exactly 3 selected courses
    if (!current.major || current.major.length !== 3) {
      toast.info("Please select all major courses before submitting.");
      return; //Stop execution here
    }
    if (!current.ojt || current.ojt.length === 0) {
      toast.info("Please select OJT.");
      return;
    }
    // Transforming selected data to the required format
    const selectedData = {
      major: current.major.map(course => course.course_id),
      minor: current.minor.map(course => course.course_id),
      mdc: current.mdc.map(course => course.course_id),
      sec: current.sec.map(course => course.course_id),
      core: current.core.map(course => course.course_id),
      mde: current.mde.map(course => course.course_id),
      electives: current.electives.map(course => course.course_id),
      vac: current.vac.map(course => course.course_id),
      aec: current.aec.map(course => course.course_id),
      ojt: current.ojt.map(course => course.course_id),

    };

    // console.log(selectedData); // Debugging

    try {
      const response = await http.get('/College/getBvocCoursegroup');
      const courseGroupData = response.data;

      const courseGroupMap = {};
      courseGroupData.forEach(group => {
        courseGroupMap[group.group_name.toLowerCase()] = group.id;
      });



      const course_group_id = {};
      for (const [key, courses] of Object.entries(selectedData)) {
        if (courses.length > 0) {
          const groupName = key;


          const groupId = courseGroupMap[groupName];

          if (groupId) {
            if (!course_group_id[groupId]) {
              course_group_id[groupId] = [];
            }
            course_group_id[groupId].push(...courses.map(course_id => ({ course_id })));
          }
        }
      }

      const college_id = localStorage.getItem("collegeid");
      const collegetype = selected.collegetype;
      const id = selected.college_discipline_id;
      const discipline_id = selected.disiplin;
      const Adimission_year = selectedAdmission.Adimission_year;
      const finalData = {

        college_id: college_id,
        discipline_id: discipline_id,
        semester_id: selctedsem,
        course_group_id,
        admission_year: Adimission_year,
        college_course_type: collegetype,
        college_discipline_id: id

      };


      const saveResponse = await http.post(`/College/BvocCoursemapSave`, finalData);

      if (saveResponse.data.status_code === "MSG1") {
        toast.success("Course Updated Successfully");

        setTimeout(() => {
          setsem(selctedsem);
          setSelected(selected);
        }, 1000); // 5000 milliseconds = 5 seconds
      }

    } catch (error) {
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");

        }, 5000);
      }

      else if (error.response.data.http_status === 422 && error.response.data.status_code == "ERR1") {
        toast.error("Validation Failed");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000); // 5000 milliseconds = 5 seconds
      }
      else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
        toast.error(error.response.data.message.message);


      }
      else if (error.response.status === 500 && error.response.data.status_code == "ERR2") {
        const actualMessage = error.response.data.data?.message || error.response.data.message || "Unknown error";
        toast.error(actualMessage);


      }
      else {
        toast.error("something went wrong");
        // setTimeout(() => {
        //   window.location.reload();
        // }, 1000); // 5000 milliseconds = 5 seconds
      }
    }
  };






  const handleCourseComponentChange = (selectedOptions, field) => {
    setCurrent(prevState => ({
      ...prevState,
      [field]: selectedOptions.map(option => ({
        course_id: option.value,
        course_name: option.label
      }))
    }));
  };

  const handledisipline = (selectedOptions) => {

    const disiplin = selectedOptions.discipline_id;
    const collegetype = selectedOptions.college_course_type
    const id = selectedOptions.college_discipline_id
    const status = selectedOptions.status;

    setSelected({ disiplin: disiplin, collegetype: collegetype, college_discipline_id: id, status: status });

  };



  useEffect(() => {


    const course_code = async () => {
      let cid = localStorage.getItem("collegeid");

      const discipline_id = selected.disiplin;
      const semesterid = selctedsem;
      const Adimission_year = selectedAdmission.Adimission_year;
      const collegetype = selected.collegetype;
      const id = selected.college_discipline_id;

      if (discipline_id && semesterid && Adimission_year) {
        try {
          const response = await http.get('/College/getBvocCoursebaskets', {
            params: {
              semester_id: semesterid,
              discipline_id: discipline_id,
              college_course_type: collegetype,
              college_discipline_id: id,
              admission_year: Adimission_year


            }
          });



          const response1 = await http.get('/College/showBvocCollegeCourse', {
            params: {
              semester_id: semesterid,
              discipline_id: discipline_id,
              college_id: cid,
              college_course_type: collegetype,
              college_discipline_id: id,
              admission_year: Adimission_year
            }
          });


          if (response.data.status_code === 'ERR5') {
            setResults(false);
          }
          else {
            setResults(true);
          }



          setResponse(response1.data.groups || [])
          setMinors(response.data.minors || []);
          setMdc(response.data.MDC || []);
          setMajor(response.data.majors || []);
          setElective(response.data.Electives || []);
          setSec(response.data.SEC || []);
          setCore(response.data.CCR || []);
          setMDE(response.data.MDE || []);
          setVAC(response.data.VAC || []);
          setAEC(response.data.AEC || []);
          setOJT(response.data.OJT || []);


        } catch (error) {
          if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
            toast.error("Invalid Token");
            setTimeout(() => {
              navigate("/college/");
            }, 5000);
          }
          else if (error.response.data.message.http_status === 429 && error.response.data.message.status_code == "ERR33") {
            toast.error(error.response.data.message.message);

          }
          else if (error.response.data.status_code === 'ERR5') {
            setResults(false);
            setMinors([]);
            setMdc([]);
            setMajor([]);
            setElective([]);
            setSec([]);
            setVAC([]);
            setAEC([]);
            setOJT([]);

          }
          else {
            toast.error("Something went wrong");
          }
          console.error('Error fetching Course data:', error);
        }
      }
    };
    if (selected !== false) {
      course_code();
    }


  }, [selected, selctedsem, selectedAdmission]);



  useEffect(() => {

    const updatedCurrent = Object.keys(current).reduce((acc, key) => {
      acc[key] = [];
      return acc;
    }, {});

    response.forEach(group => {

      const groupName = group.group_name.toLowerCase();

      if (updatedCurrent.hasOwnProperty(groupName)) {
        updatedCurrent[groupName] = group.courses.map(course => ({
          course_id: course.course_id,
          course_name: course.course_name

        }));
      }

    });



    setCurrent(updatedCurrent);


  }, [response]);




  const cancelForm = () => {
    window.location.reload();
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  //custom discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };
  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center">
                        <h5>B.Voc Program Mapping</h5>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="card-body pdg">
                        <div className="card-body custom-input">
                          <div className="row">
                            <div className="col">
                              <div className="mb-3 row">

                                <div className="col-md-6">
                                  <label className="">Admission Year<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="Adimission_year"
                                    name="Adimission_year"
                                    className="form"
                                    styles={customStyles}
                                    options={[

                                      { value: '2025', label: '2025' },
                                    ]}
                                    onChange={handleadmissionyear}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="">Discipline<span className="errorclr">*</span></label>


                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    styles={disciplineStyles}
                                    options={flag ? [{ value: '0', label: 'No data found' }] : discipline
                                      .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name)) // Sort the colleges array alphabetically
                                      .map(disciplines => ({

                                        value: disciplines.college_discipline_id,
                                        college_course_type: disciplines.college_course_type,
                                        college_discipline_id: disciplines.college_discipline_id,
                                        discipline_id: disciplines.discipline_id,
                                        label: disciplines.discipline_name,
                                        status: disciplines.event_status
                                      }))}
                                    onChange={handledisipline}

                                  />
                                </div>



                              </div>


                              <div className="col-md-12">


                                <ul className="nav nav-tabs justify-content-center">
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 1 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(1)}
                                    >
                                      Sem 1
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem == 2 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(2)}

                                    >
                                      Sem 2
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 3 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(3)}

                                    >
                                      Sem 3
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 4 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(4)}

                                    >
                                      Sem 4
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 5 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(5)}

                                    >
                                      Sem 5
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 6 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(6)}

                                    >
                                      Sem 6
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 7 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(7)}

                                    >
                                      Sem 7
                                    </a>
                                  </li>
                                  <li className="nav-item">
                                    <a
                                      className={`nav-link ${selctedsem === 8 ? 'active selected-tab' : ''}tab-link`}
                                      onClick={() => setsem(8)}

                                    >
                                      Sem 8
                                    </a>
                                  </li>
                                </ul>


                              </div>

                              <div className="pgm-map-box">
                                {/* <div className="table-responsive"> */}

                                <table className="display dataTable table-striped table-bordered table-responsive">


                                  <tbody>

                                    {Core.length > 0 && getresults === true && (
                                      <tr>
                                        <td>Core</td>
                                        <td>
                                          <Select
                                            id="core_select"
                                            name="core_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={Core.map(cors => ({
                                              value: cors.course_id,
                                              label: cors.course_name
                                            }))}
                                            value={Core.filter(major =>
                                              current.core.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'core')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}

                                          />
                                        </td>


                                      </tr>
                                    )}

                                    {Major.length > 0 && getresults === true && (
                                      <tr className="prgm-bod">
                                        <td>Major<span className="errorclr">*</span></td>
                                        <td>
                                          <Select
                                            id="major_select"
                                            name="major_select"
                                            styles={customStyles}

                                            className="form-control ht"

                                            isMulti
                                            options={Major.map(major => ({
                                              value: major.course_id,
                                              label: major.course_name
                                            }))}
                                            value={Major.filter(major =>
                                              current.major && current.major.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'major')}
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {minors.length > 0 && getresults === true && (
                                      <tr>
                                        <td>Minors</td>
                                        <td>
                                          <Select
                                            id="minor_select"
                                            name="minor_select"
                                            styles={customStyles}

                                            className="form-control ht"

                                            isMulti
                                            options={minors.map(minors => ({
                                              value: minors.course_id,
                                              label: minors.course_name
                                            }))}
                                            value={minors.filter(major =>
                                              current.minor.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'minor')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {mdc.length > 0 && getresults === true && (
                                      <tr>
                                        <td>MDC</td>
                                        <td>
                                          <Select
                                            id="mdc_select"
                                            name="mdc_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={mdc.map(mdcs => ({
                                              value: mdcs.course_id,
                                              label: mdcs.course_name
                                            }))}
                                            value={mdc.filter(major =>
                                              current.mdc.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'mdc')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {SEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>SEC</td>
                                        <td>
                                          <Select
                                            id="sec_select"
                                            name="sec_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={SEC.map(secs => ({
                                              value: secs.course_id,
                                              label: secs.course_name
                                            }))}
                                            value={SEC.filter(major =>
                                              current.sec.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'sec')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}




                                    {MDE.length > 0 && getresults === true && (
                                      <tr>
                                        <td>MDE</td>
                                        <td>
                                          <Select
                                            id="mde_select"
                                            name="mde_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={MDE.map(mdes => ({
                                              value: mdes.course_id,
                                              label: mdes.course_name
                                            }))}
                                            value={MDE.filter(major =>
                                              current.mde.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'mde')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>

                                      </tr>
                                    )}
                                    {VAC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>VAC</td>
                                        <td>
                                          <Select
                                            id="vac_select"
                                            name="vac_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={VAC.map(vacs => ({
                                              value: vacs.course_id,
                                              label: vacs.course_name
                                            }))}
                                            value={VAC.filter(major =>
                                              current.vac.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'vac')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                    {AEC.length > 0 && getresults === true && (
                                      <tr>
                                        <td>AEC</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={AEC.map(aecs => ({
                                              value: aecs.course_id,
                                              label: aecs.course_name
                                            }))}
                                            value={AEC.filter(major =>
                                              current.aec.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'aec')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}



                                    {Elective.length > 0 && getresults === true && (
                                      <tr>
                                        <td>Elective</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            styles={customStyles}
                                            className="form-control ht"
                                            isMulti
                                            options={Elective.map(electives => ({
                                              value: electives.course_id,
                                              label: electives.course_name,
                                              flag: electives.flag
                                            }))}
                                            formatOptionLabel={(e) => (
                                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                                <span>{e.label}</span>
                                                {e.flag === "1" && (
                                                  <span
                                                    style={{
                                                      backgroundColor: '#28a745',
                                                      color: 'white',
                                                      borderRadius: '4px',
                                                      padding: '2px 6px',
                                                      fontSize: '11px',
                                                      marginLeft: '6px'
                                                    }}
                                                  >
                                                    sig
                                                  </span>
                                                )}
                                              </div>
                                            )}
                                            value={Elective.filter(major =>
                                              current.electives.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name,
                                              flag: selectedMajor.flag
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'electives')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />

                                        </td>
                                      </tr>
                                    )}

                                    {OJT.length > 0 && getresults === true && (
                                      <tr>
                                        <td>OJT</td>
                                        <td>
                                          <Select
                                            id="aec_select"
                                            name="aec_select"
                                            className="form-control ht"
                                            styles={customStyles}
                                            isMulti
                                            options={OJT.map(ojts => ({
                                              value: ojts.course_id,
                                              label: ojts.course_name
                                            }))}
                                            value={OJT.filter(major =>
                                              current.ojt.some(selectedMajor => selectedMajor.course_id === major.course_id)
                                            ).map(selectedMajor => ({
                                              value: selectedMajor.course_id,
                                              label: selectedMajor.course_name
                                            }))}
                                            onChange={(selectedOptions) => handleCourseComponentChange(selectedOptions, 'ojt')}
                                            required
                                            hideSelectedOptions={false}
                                            closeMenuOnSelect={true}
                                            isDisabled={selctedsem !== active}
                                          />
                                        </td>
                                      </tr>
                                    )}

                                  </tbody>

                                </table>

                                {selected && getresults ? (
                                  <div className="col-md-12 txt-aln pdg11">
                                    {selctedsem === active && selected.status === "active" && (
                                      <div>
                                        <button className="btn btn-primary me-3" type="submit" onClick={save}>Submit</button>
                                        <input className="btn btn-light" type="reset" value="Cancel" onClick={cancelForm} />
                                      </div>
                                    )}
                                  </div>
                                ) : (
                                  selected === false && getresults === false ? (
                                    <p className="txt-aln">No data available. Please select Discipline & Adimission Year</p>
                                  ) : (

                                    <p className="txt-aln">No data available..</p>
                                  )
                                )
                                }




                                {/* </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
